module.exports = __webpack_public_path__ + "media/images/games/world_culture_awareness/22-4b909c1a40ee3f761c6e2ce22917242f.png";